import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiService from '../services/api';

const UserPoints = () => {
  const [points, setPoints] = useState([]);
  const [shopOrders, setShopOrders] = useState([]);
  const [shopOrdersError, setShopOrdersError] = useState('');
  // 只保留每个活动最新的一条积分记录（按awarded_at降序）
  const uniquePoints = React.useMemo(() => {
    const seen = new Set();
    return points.filter(p => {
      if (p.activity_id === null || p.activity_id === undefined) return true; // 管理员操作类积分不过滤
      if (seen.has(p.activity_id)) return false;
      seen.add(p.activity_id);
      return true;
    });
  }, [points]);
  const [totalPoints, setTotalPoints] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [activityStatusMap, setActivityStatusMap] = useState({});

  useEffect(() => {
    const fetchPoints = async () => {
      try {
        setLoading(true);
        
        const response = await apiService.getUserPoints();
        
        setPoints(response.data.points);
        setTotalPoints(response.data.total_points);
      } catch (err) {
        setError('获取积分记录失败');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    // 同时获取积分和报名状态
    const fetchAll = async () => {
      try {
        setLoading(true);
        const [pointsRes, activitiesRes] = await Promise.all([
          apiService.getUserPoints(),
          apiService.getUserActivities()
        ]);
        setPoints(pointsRes.data.points);
        setTotalPoints(pointsRes.data.total_points);
        // 构建 activity_id -> status 的映射
        const statusMap = {};
        (activitiesRes.data || []).forEach(ua => {
          if (ua.activity_id && ua.status) statusMap[ua.activity_id] = ua.status;
        });
        setActivityStatusMap(statusMap);
      } catch (err) {
        setError('获取积分或活动状态失败');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();

    // 获取积分兑换订单
    const fetchShopOrders = async () => {
      try {
        const res = await apiService.getShopOrders();
        setShopOrders(res.data);
      } catch (e) {
        setShopOrdersError('获取兑换记录失败');
      }
    };
    fetchShopOrders();
  }, []);

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">加载中...</p>
      </div>
    );
  }

  return (
    <div>
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body text-center">
              <h2 className="mb-3">我的总积分</h2>
              <h1 className="display-1 text-primary">{totalPoints}</h1>
            </div>
          </div>
        </div>
      </div>

      <h2 className="mb-4">积分记录</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      
      {points.length === 0 ? (
        <div className="alert alert-info">您还没有获得任何积分</div>
      ) : (
        <div className="card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>活动名称</th>
                    <th>变动原因</th>
                    <th>获得积分</th>
                    <th>获得时间</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {uniquePoints.map((point, idx) => (
                    <tr key={point.id || idx}>
                      <td>{
                        point.activity ? point.activity.name :
                        (point.activity_id === null && point.points < 0 ? '积分兑换' : '管理员操作')
                      }</td>
                      <td>{point.reason || ''}</td>
                      <td>
  {point.activity && point.activity_id && activityStatusMap[point.activity_id] && activityStatusMap[point.activity_id] !== 'completed' ? (
  <>
    <span className="badge bg-info">
      {point.points >= 0 ? '+' : ''}{point.points}
    </span>
    <br />
    <span style={{ fontSize: '0.7em', color: '#666' }}>
      {activityStatusMap[point.activity_id] === 'registered' ? '未完成' : activityStatusMap[point.activity_id] === 'attended' ? '获取中' : activityStatusMap[point.activity_id]}
    </span>
  </>
) : (
  <span className={`badge ${point.points >= 0 ? 'bg-success' : 'bg-danger'}`}>
    {point.points >= 0 ? '+' : ''}{point.points}
  </span>
)}
</td>
                      <td>{new Date(point.awarded_at).toLocaleString()}</td>
                      <td>
                        {point.activity_id ? (
                          <Link to={`/activities/${point.activity_id}`} className="btn btn-sm btn-outline-primary">
                            查看活动
                          </Link>
                        ) : (
                          <button className="btn btn-sm btn-outline-secondary" disabled>
                            {point.points < 0 ? '积分兑换' : '管理员操作'}
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {/* 积分兑换记录 */}
      <div className="mt-5">
        <h2 className="mb-4">积分兑换记录</h2>
        {shopOrdersError && <div className="alert alert-danger">{shopOrdersError}</div>}
        {shopOrders.length === 0 ? (
          <div className="alert alert-info">暂无兑换记录</div>
        ) : (
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>兑换时间</th>
<th>消耗积分</th>
<th>兑换数量</th>
<th>单价</th>
<th>商品名称</th>
<th>商品链接</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shopOrders.map(order => (
  <tr key={order.id}>
    <td>{order.created_at ? order.created_at.split('.')[0].replace('T', ' ') : ''}</td>
    <td className="text-danger">-{order.points_required * order.quantity}</td>
    <td>{order.quantity}</td>
    <td>{order.points_required}</td>
    <td>{order.product_name}</td>
    <td>
      {order.product_url ? (
        <a href={order.product_url} target="_blank" rel="noopener noreferrer">查看商品</a>
      ) : (
        <span className="text-muted">无</span>
      )}
    </td>
  </tr>
))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserPoints;
